/// <amd-module name="Tfs/Platform/ProductFeatures" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export interface IProductFeaturesData {
    features: { [featureId: string]: IProductFeature };
}

/**
 * A product feature (service shown in the Services picker).
 */
export interface IProductFeature {
    /**
     * The full contribution id of the feature
     */
    id: string;

    /**
     * The friendly name of the product feature (service)
     */
    name: string;

    /**
     * The id of the default route associated with this feature
     */
    defaultRouteId: string;

    /**
     * The id of the acquisition route associated with this feature
     */
    acquisitionRouteId?: string;
}

/**
 * Service for getting TFS-centric information about the current page (like project information)
 */
export interface ITfsProductFeaturesService extends IVssService {
    /**
     * Gets the product feature with the given id.
     */
    getProduct(featureId: string): IProductFeature | undefined;
}

class TfsProductFeaturesService extends VssService implements ITfsProductFeaturesService {
    public getProduct(featureId: string): IProductFeature | undefined {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const productsData = contributionService.getData<IProductFeaturesData>("ms.vss-tfs-web.product-features-data-provider");
        if (productsData && productsData.features) {
            return productsData.features[featureId];
        } else {
            return undefined;
        }
    }
}

Services.add("ITfsProductFeaturesService", { serviceFactory: TfsProductFeaturesService });
